import React, { FunctionComponent, useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import { Helmet } from "react-helmet-async";
import { useTerminalsStyles } from "./Terminals/useTerminalsStyles";
import { Terminals } from "./Terminals/Terminals";
import { TerminalForm } from "./Terminals/TerminalForm";
import { useStore } from "../../store";

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}
type permissionType = {
  permission_id: number;
  is_add: boolean;
  is_edit: boolean;
  is_view: boolean;
  is_delete: boolean;
};
export const TabPanel: FunctionComponent<TabPanelProps> = ({
  children,
  value,
  index,
}) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      //   {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
};

export const TerminalMaster = () => {
  const classes = useTerminalsStyles();

  const [value, setValue] = React.useState(0);
  const [editId, setEditId] = React.useState(0);
  const [viewTerminalPermission, setViewTerminalPermission] = useState<boolean>(
    false
  );
  const [editTerminalPermission, setEditTerminalPermission] = useState<boolean>(
    false
  );
  const [addTerminalPermission, setAddTerminalPermission] = useState<boolean>(
    false
  );
  const [user] = useStore("auth", "user");

  useEffect(() => {
    const terminalPermission = user.permissions.find(
      (permission: permissionType) => permission.permission_id === 9
    );
    if (user.is_super_admin === true) {
      setAddTerminalPermission(true);
      setViewTerminalPermission(true);
      setEditTerminalPermission(true);
    } else {
      if (terminalPermission) {
        if (terminalPermission.is_add === true) {
          setAddTerminalPermission(true);
        }
        if (terminalPermission.is_view === true) {
          setViewTerminalPermission(true);
        }
        if (terminalPermission.is_edit === true) {
          setEditTerminalPermission(true);
        }
        // if (terminalPermission.is_view === false) {
        //   setValue(1);
        //   setViewTerminalPermission(false);
        // }
        // if (
        //   terminalPermission.is_add === false &&
        //   terminalPermission.is_edit === false &&
        //   terminalPermission.is_view === false
        // ) {
        //   setAddTerminalPermission(false);
        //   setEditTerminalPermission(false);
        //   setViewTerminalPermission(false);
        // }
      }
    }
  });
  const handleChange = (event: React.ChangeEvent<{}>, newValue: number) => {
    setValue(newValue);
    setEditId(0);
  };

  const goBackToList = () => {
    setValue(0);
    setEditId(0);
  };

  const goToEdit = (id: number) => {
    setEditId(id);
    setValue(1);
  };

  return (
    <>
      <Helmet>
        <title>Terminals</title>
      </Helmet>
      <div className={classes.root}>
        <AppBar position="static">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="simple tabs example"
          >
            <Tab
              label="Terminal List"
              style={{ display: viewTerminalPermission ? "" : "none" }}
            />
            {editId === 0 ? (
              <Tab
                label="Create Terminal"
                style={{ display: addTerminalPermission ? "" : "none" }}
              />
            ) : (
              <Tab
                label="Edit Terminal"
                style={{ display: editTerminalPermission ? "" : "none" }}
                disabled
              />
            )}
          </Tabs>
        </AppBar>
        <TabPanel value={value} index={0}>
          {viewTerminalPermission ? (
            <Terminals
              goToEdit={goToEdit}
              editTerminalPermission={editTerminalPermission}
            />
          ) : (
            " "
          )}
        </TabPanel>
        <TabPanel value={value} index={1}>
          <TerminalForm
            terminalId={editId === 0 ? "new" : editId}
            goBackToList={goBackToList}
          />
        </TabPanel>
      </div>
    </>
  );
};
